import {ApiPaths, ApiService, SetAuthToken, ApiStatus} from '../../utils/ApiService';
import {MAIN_LOAD_TRUE, MAIN_LOAD_FALSE, SET_AUTH_USER,
     OTP_SENT_SUCCESS, OTP_VALID_FAILS, LOGIN_SUCCESS, DISPLAY_MESSAGE, 
     DISPLAY_ERROR,OTP_VALID_SUCCESS,
     GET_CONSTITUTION_OF_FIRM,
     GET_CHANNEL_PARTNER,
     GET_PROJECTS,
     GET_CP_LEAD,
     GET_CP_DASHBOARD,
     GET_CP_LEAD_SITE_VISIT,
     GET_CP_LEAD_DETAIL,
     GET_CALL_STATUS,
     GET_BD_USER,GET_COUNTRY_CODE} from './types';
import { toast } from 'react-toastify';
const UserData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null ;
export const userRegister_action = (data) => {
    return dispatch => {
        dispatch(mainLoadingTrue());
        return ApiService.post(ApiPaths.LOGIN, data).then(response => {
                const {data}  = response;
                dispatch(mainLoadingFalse());
                if(!data.error)
                {
                    // dispatch(displayMessage(data.message));
                    toast.success(data.message);
                    // setTimeout(function(){ dispatch(displayMessage(""))}, 3000);
                    dispatch(otpSentSuccess());
                }
                else
                    {
                        toast.error(data.message);
                        // dispatch(displayError(data.message));
                        // setTimeout(function(){ dispatch(displayError(""))}, 3000);
                    }
            })
            .catch(err => {
                dispatch(mainLoadingFalse());
                displayError('Failed, try again later');
            })
    }
}

export const otpVerify_action = (data) => {
    return dispatch => {
        dispatch(mainLoadingTrue());
        localStorage.clear()
        dispatch(otpSentfails());
        return ApiService.post(ApiPaths.OTPVERIFY, data).then(response => {
                const {data}  = response;
                dispatch(mainLoadingFalse());
                if(!data.error)
                {
                    // dispatch(displayMessage(data.message));
                    toast.success(data.message);
                    localStorage.setItem('user', JSON.stringify(data.user));
                    dispatch(otpValidSuccess());
                    // setTimeout(function(){ dispatch(displayMessage(""))}, 3000);
                }
                else{
                    toast.error(data.message);
                    dispatch(otpSentfails());
                    // dispatch(displayError(data.message));
                    // setTimeout(function(){ dispatch(displayError("")); }, 3000);
                }
            })
            .catch(err => {
                dispatch(otpSentfails());
                dispatch(mainLoadingFalse());
                displayError('Failed, try again later');
            })
    }
}

export const mainLoadingTrue = () => {
    return {
        type : MAIN_LOAD_TRUE
    }
}
export const mainLoadingFalse = () => {
    return {
        type : MAIN_LOAD_FALSE
    }
}

export const displayMessage = (message) => {
    return {
        type : DISPLAY_MESSAGE,
        payload : {
            message : message
        }
    }
}

export const otpSentSuccess = () => {
    return {
        type : OTP_SENT_SUCCESS
    }
}

export const otpSentfails = () => {
    return {
        type : OTP_VALID_FAILS
    }
}



export const otpValidSuccess = () => {
    return {
        type : OTP_VALID_SUCCESS
    }
}


export const setAuthUser = (auth_user) => {
    return {
        type : SET_AUTH_USER,
        payload : {
            auth_user : auth_user
        }
    }
}

export const displayError = (error) => {
    return {
        type : DISPLAY_ERROR,
        payload : { 
            error : error
        }
    }
}


export const getConstitutionOfFirm_action = (data) => {
  const initialPayload = {
    // userID: UserData["channel_partner_id"],

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CONSTITUTION_OF_FIRM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getConstitutionOfFirm(data));
        } else {
          dispatch(getConstitutionOfFirm({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getConstitutionOfFirm([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getConstitutionOfFirm = (data) => {
  return {
    type: GET_CONSTITUTION_OF_FIRM,
    payload: data
  };
};


export const CreateVendor_action = (data) => {
  console.log(data, "dataAction");
  let initialPayload = new FormData();

  // initialPayload.append("userID", LoginuserId);
    // initialPayload.append("userID", UserData?.channel_partner_id);
    initialPayload.append("userID", data.referenceID);
  initialPayload.append("constitutionID", data.constitutionID);
  initialPayload.append("vendorCategory", data.vendorCategory);
  initialPayload.append("vendorName", data.vendorName);
  initialPayload.append("vendorEmailID", data.vendorEmailID);
  initialPayload.append("vendorPanNumber", data.vendorPanNumber);
  initialPayload.append("vendorGstNumber", data.vendorGstNumber);
  initialPayload.append("vendorMsmeNumber", data.vendorMsmeNumber);
  initialPayload.append("isGst", data.isGst);
  initialPayload.append("isPan", data.isPan);
  initialPayload.append("isMsme", data.isMsme);
  initialPayload.append("referenceID", data.referenceID);
  initialPayload.append("contactNumber", data.contactNumber);
  initialPayload.append("contactPerson", data.contactPerson);
  initialPayload.append("remarks", data.remarks);
  initialPayload.append("documentGst", data.documentGst);
  initialPayload.append("documentGstNOC", data.documentGstNOC);
  initialPayload.append("documentPanNOC", data.documentPanNOC);
  initialPayload.append("documentPan", data.documentPan);
  initialPayload.append("documentMsme", data.documentMsme);
  initialPayload.append("documentMsmeNOC", data.documentMsmeNOC);
  initialPayload.append("vendorReraNumber", data.vendorReraNumber);
  initialPayload.append("documentReraNOC", data.documentReraNOC);
  initialPayload.append("documentRera", data.documentRera);
  initialPayload.append("isRera", data.isRera);
  // initialPayload.append("userID", data.userID);

//   const config = {
//     headers: { "content-type": "multipart/form-data" }
//   };

//   return async (dispatch) => {
//     dispatch(mainLoadingTrue());

//     try {
//       const response = await ApiService.post(
//         ApiPaths.CREATE_VENDOR,
//         initialPayload,
//         config
//       );
//       const { data } = response;
//       dispatch(mainLoadingFalse());

// if (!data.error) {
//   dispatch(
//     displayMessage({
//       text: data.message,
//       type: "success"
//     })
//   );
//   // toast.success(data.message);
//   dispatch(
//     displayMessage({
//       text: data.message,
//       type: "error"
//     })
//   );
//   // toast.error(data.message);   
// }


//       return data; 
//     } catch (error) {
//       dispatch(mainLoadingFalse());
//       dispatch(
//         displayMessage({
//           text: "An error occurred",
//           type: "error"
//         })
//       );

//       return { error: true, message: "An error occurred" }; // Return an error object
//     }
//   };
// };

const config = {
    headers: { "content-type": "multipart/form-data" }
  };

  return async (dispatch) => {
    dispatch(mainLoadingTrue());
    try {
      const response = await ApiService.post(
        ApiPaths.CREATE_VENDOR,
        initialPayload,
        config
      );
      return response.data; 
    } catch (error) {
      dispatch(mainLoadingFalse());
      const errorMessage = error?.response?.data?.message || "An unexpected error occurred.";
      return { error: true, message: errorMessage };
    } finally {
      dispatch(mainLoadingFalse());
    }
  };
};


export const getChannelPartner_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],
    channelPartnerID: UserData["channel_partner_id"],
    status: "",
    generalSearch: "",
    sortOrder: "",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CHANNEL_PARTNER, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getChannelPartnerSuccess(data));
        } else {
          dispatch(getChannelPartnerSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getChannelPartnerSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getChannelPartnerSuccess = (data) => {
  return {
    type: GET_CHANNEL_PARTNER,
    payload: data
  };
};


// export const addChannelPartner_action = (data) => {
//     return dispatch => {
//         dispatch(mainLoadingTrue());
//         if(UserData){
//             const body = {
//                 userID : UserData["channel_partner_id"],
//                 channelPartnerID : UserData["channel_partner_id"],
//                 ...data
//             }
//         return ApiService.post(ApiPaths.ADD_CHANNEL_PARTNER, body).then(response => {
//                 const {data}  = response;
//                 dispatch(mainLoadingFalse());
//                 if(!data.error)
//                 {
//                     dispatch(displayMessage(data.message)); 
//                     toast.success(data.message);
//                 }
//                 else
//                 {
//                     dispatch(displayError(data.message));
//                        toast.error(data.message);   
//                     setTimeout(function(){ dispatch(displayError(""))}, 3000);
//                 }
//             })
//             .catch(err => {
//                 dispatch(mainLoadingFalse());
//                 displayError('Failed, try again later');
//             })
//         }else{
//             console.log("redirect to home")
//         }
//     }
// }

// ADD action optimized

export const addChannelPartner_action = (data) => {
    return dispatch => {
        dispatch(mainLoadingTrue());
        if (UserData) {
            const body = {
                userID: UserData["channel_partner_id"],
                channelPartnerID: UserData["channel_partner_id"],
                ...data
            }
            return ApiService.post(ApiPaths.ADD_CHANNEL_PARTNER, body)
                .then(response => {
                    const { data } = response;
                    dispatch(mainLoadingFalse());
                    // Always return {error, message}
                    return {
                        error: !!data.error,
                        message: data.message || (data.error ? 'Failed to add Partner.' : 'Channel partner added!')
                    }
                })
                .catch(err => {
                    dispatch(mainLoadingFalse());
                    return {error: true, message: 'Failed, try again later'}; // Ensure message is always present!
                })
        } else {
            return Promise.resolve({ error: true, message: 'No user data' });
        }
    }
}



export const getProjects_action = (data) => {
    return dispatch => {    
        dispatch(mainLoadingTrue());
        if(UserData){
        const body = {
            // mobileNumber : UserData["crm_customer_contact_no_one"],
            // userID : UserData["crm_customer_details_id"],
            ...data
        }
        return ApiService.post(ApiPaths.GET_PROJECTS, body)
            .then(response => {
                const { data } = response;
                dispatch(mainLoadingFalse());
                if(!data.error) {
                    dispatch(getProjects(data.project));
                    dispatch(displayMessage(data.message));
                } else {
                    dispatch(displayError(data.message));
                }
            })
            .catch(err => {
                dispatch(mainLoadingFalse());
                displayError('Failed, try again later');
            })
        }else{
            console.log("redirect to home") 
        }
        dispatch(mainLoadingFalse());
    }   
}

export const getProjects = (data) => {
    return {
        type : GET_PROJECTS,
        payload : {data}
    }
}

export const createCpLead_action = (data) => {
    return dispatch => {
        dispatch(mainLoadingTrue());
        if(UserData){
            const body = {
                userID : UserData["channel_partner_id"],
                channelPartnerID : UserData["channel_partner_id"],
                
                ...data
            }
        return ApiService.post(ApiPaths.CREATE_CP_LEAD, body).then(response => {
                const {data}  = response;
                dispatch(mainLoadingFalse());
                if(!data.error)
                {
                    dispatch(displayMessage(data.message)); 
                     toast.success(data.message);

                }
                else
                {
                    dispatch(displayError(data.message));
                      toast.error(data.message);   
                    setTimeout(function(){ dispatch(displayError(""))}, 3000);
                }
            })
            .catch(err => {
                dispatch(mainLoadingFalse());
                displayError('Failed, try again later');
            })
        }else{
            console.log("redirect to home")
        }
    }
}

export const getCpLead_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],
    channelPartnerID: UserData["channel_partner_id"],
    status: "",
    generalSearch: "",
    sortOrder: "",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CP_LEAD, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCpLeadSuccess(data));
        } else {
          dispatch(getCpLeadSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCpLeadSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getCpLeadSuccess = (data) => {
  return {
    type: GET_CP_LEAD,
    payload: data
  };
};


export const getCpDashboard_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],
    mobileNo: UserData["contact_number"],


    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CP_DASHBOARD, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCpDashboardSuccess(data));
        } else {
          dispatch(getCpDashboardSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCpDashboardSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getCpDashboardSuccess = (data) => {
  return {
    type: GET_CP_DASHBOARD,
    payload: data
  };
};


export const getCpLeadSiteVisit_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],
    channelPartnerID: UserData["channel_partner_id"],
    status: "",
    sortOrder: "",


    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CP_LEAD_SITE_VISIT, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCpLeadSiteVisitSuccess(data));
        } else {
          dispatch(getCpLeadSiteVisitSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCpLeadSiteVisitSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getCpLeadSiteVisitSuccess = (data) => {
  return {
    type: GET_CP_LEAD_SITE_VISIT,
    payload: data
  };
};

export const getCpLeadDetail_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],


    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CP_LEAD_DETAIL, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCpLeadDetailSuccess(data));
        } else {
          dispatch(getCpLeadDetailSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCpLeadDetailSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getCpLeadDetailSuccess = (data) => {
  return {
    type: GET_CP_LEAD_DETAIL,
    payload: data
  };
};


export const getCallStatus_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],


    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_CALL_STATUS, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCallStatusSuccess(data));
        } else {
          dispatch(getCallStatusSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCallStatusSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getCallStatusSuccess = (data) => {
  return {
    type: GET_CALL_STATUS,
    payload: data
  };
};

export const getBdUser_action = (data) => {
  const initialPayload = {
    // userID: UserData["channel_partner_id"],
    departmentID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.BD_USER, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getBdSuccess(data.user));
        } else {
          dispatch(getBdSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getBdSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getBdSuccess = (data) => {
  return {
    type: GET_BD_USER,
    payload: data
  };
};




export const getCountryCode_action = (data) => {
  const initialPayload = {
    userID: UserData["channel_partner_id"],
   
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ApiService.post(ApiPaths.GET_COUNTRY_CODE, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCountryCodeSuccess(data));
        } else {
          dispatch(getCountryCodeSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCountryCodeSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCountryCodeSuccess = (data) => {
  return {
    type: GET_COUNTRY_CODE,
    payload: data
  };
};

